/*
AuthentView
*/

import React from 'react';
import { Navigate, useNavigate  } from "react-router-dom";
import { globals, authent_form} from '../Components/Globals/Globals';
import {DsAdminAuthent} from "datasync-admin-authent"
import { DsDynamicForm } from 'datasync-dynamic-form';
import { useDispatch, useSelector } from 'react-redux';
import { loginSuccess, loginFailure, logout } from '../redux/authSlice';
import { loadEvents, revertAllEvents } from '../redux/eventSlice';
import {Button} from "reactstrap";
import {openModal} from '../redux/modalSlice'

const AuthentView = () => {
    const fake_user = {"version":"Debug","current_user":{"data_guid":"98cabcb6-7f44-4b6c-94bc-1e95c27b9837",data_blob:{data_tier:{"e_mail":"pmabiala@me.com", "admin":"Oui"}}}}
    const dispatch = useDispatch()
    let navigate = useNavigate()
    let {isAuthenticated} = useSelector((state) => state.auth);
    let {loadEvents_result} = useSelector((state) => state.events);

    React.useEffect(() => {
        let isMounted = true

        //Automatically redirect to Admin console page as all data are loaded
        if (
            isAuthenticated 
            && loadEvents_result.status == "succeeded"
        ){
            //Loading is done, the redirect to the landing page
            if (globals.parameters.debugging)
                console.log("LoginView.js::loading done...")
            navigate("/");//Back to home page
        }

        // If status is !loading, then fetch partners data from the API
        if (isAuthenticated && loadEvents_result.status === 'idle'){
            if (globals.parameters.debugging)
                console.log("LoginView::Loading stats...")
            dispatch(loadEvents());
        }

        // Cleanup function
        return () => {
            isMounted = false
        }
    }, [isAuthenticated, dispatch, loadEvents_result]);

    const onAdminConnectHandler = (p_current_user) => {
        dispatch(loginSuccess(p_current_user));//Call reducer

        if (globals.parameters.debugging){
            console.log("onAdminConnectHandler user:", p_current_user);
        }

        //navigate("/authent")
    }
    
    //rendering
    return (
        <div className="view-container">
            {/* Full width main picture */}
                <div className="body-page-container">
                        <h4>Connexion</h4>
                        {/* Laïus introduction de la page*/}
                        <div className="introduction-container">
                            <p>Veuillez entrer vos informations, afin de vous authentifier et accèder à la console d'Administration.
                            <br/>Authentifiez-vous&nbsp;!</p>
                        </div>
                        <DsDynamicForm/>
                        
                        <DsAdminAuthent 
                            form = {authent_form}
                            obsolete_filter_format = {false}
                            datasync_url = {globals.datasync_service.url}
                            mailsync_url = {globals.mailsync.url}
                            token_email_display_sender = "ne_pas_repondre@thononadvent.com"
                            company_guid_disabled = {globals.datasync.uNSECURED_thononadvent_company_guid}
                            company_guid = {"4"}
                            table_guid= {globals.datasync.admin_users_table_guid}
                            allow_spaces_in_json={globals.parameters.production}
                            beforeAdminGranted={(p_o_user_data_block)=>{
                                                    try{
                                                        console.log (`${p_o_user_data_block.data_blob.data_tier.e_mail} has requests access`)
                                                        return (p_o_user_data_block.data_blob.data_tier.enabled == "Oui")
                                                    }
                                                    catch(e){
                                                        alert(`beforeAdminGranted raises error ${e}`)
                                                        console.error(`beforeAdminGranted raises error ${e}`)
                                                    }
                                                }}
                            onAdminFailed = {(p_error_object) => {alert(`Authentication error raised with error_code:${p_error_object.code} and message:${p_error_object.msg}`)}}
                            onAdminGranted={(record)=>{onAdminConnectHandler(record);}}
                            onPartnerGranted={null}/>
            </div>
            {globals.parameters.debugging &&
            <>
                <Button onClick={()=>{dispatch(loginSuccess(fake_user));}}>Connect</Button>
                <Button onClick={()=>{dispatch(openModal({title:"Bonjour Pat"}));}}>Ok Dialog</Button>
                <Button onClick={()=>{dispatch(openModal({title:"Are you agree Pat ?", okCallBack:(DialogObject)=>{alert("Ok pushed !")}, cancelCallBack:(DialogObject)=>{alert("Cancel pushed !")}}));}}>Confirm Dialog</Button>
                <Button onClick={()=>{dispatch(logout());dispatch(revertAllEvents());dispatch(logout());}}>DisConnect</Button>
            </>}
        </div>
        );
}

export default AuthentView;